import { useEffect, useState } from "react";
import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { AttendanceLocalUser } from "../../../../../../../../../@types/attendance-local-user";
import DeleteConfirmationModal from "../../../../../../../../../Components/ConfirmDelete";
import { useAttendanceLocalUserDelete } from "../../../../../../../../../services/api-tansquery/attendance-local/user/delete";

type TableActionsProps = {
    id: AttendanceLocalUser["id"];
    item: AttendanceLocalUser["nome_completo"];
};

export default function UserTableActions({ id, item }: TableActionsProps) {
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
    const mutation = useAttendanceLocalUserDelete(id);

    function handleOpenModalRemove() {
        setOpenModalDelete(true);
    }

    function handleClose() {
        setOpenModalDelete((modal) => !modal);
    }

    async function handleDelete() {
        await mutation.mutateAsync();
    }

    useEffect(() => {
        if (mutation.isSuccess) {
            handleClose();
        }
    }, [mutation.isSuccess]);

    return (
        <>
            <IconButton onClick={handleOpenModalRemove}>
                <Delete htmlColor="#706E7A" />
            </IconButton>
            <DeleteConfirmationModal
                onClose={handleClose}
                onConfirm={handleDelete}
                open={openModalDelete}
                loading={mutation.isLoading}
                title="Remover Usuário"
                legend={[
                    "Você está prestes a remover o usuário do local de atendimento.",
                    "Tem certeza que deseja continuar?"
                ]}
            />
        </>
    );
}
